import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";

export const plantProfileRedirectGuard = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const symbol = route.queryParams["symbol"];

  if (symbol) {
    router.navigate(["/plant-profile", symbol], { replaceUrl: true });
    return false;
  }

  return true;
};
